import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../Main';

const useForm = () => {
  const { isAuth } = React.useContext(AuthContext);
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [recentBook, setRecentBook] = useState([]);
  const [mostViewedBook, setMostViewedBook] = useState([]);
  const [newestAdded, setNewestAdded] = useState([]);
  const [newestPublished, setNewestPublished] = useState([]);
  const [favoritesBook, setFavoritesBook] = useState([]);

  const [authors, setAuthors] = useState([]);
  const [categories, setCategories] = useState([]);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getBook = (queryType = 'default') => {
    return AxiosInstance.get(`book${isAuth ? '' : '/public'}?queryType=${queryType}&limit=15`)
      .then((response) => {
        return response.data.items;
      })
      .catch((error) => {
        return [];
      });
  };

  const getCategories = () => {
    AxiosInstance.get('category')
      .then((response) => {
        const listCategory = response.data.map((category) => {
          return { id: category.children_id, name: category.children_name, parent: category.category_name };
        });
        setCategories(listCategory);
      })
      .catch((error) => {});
  };

  const getAuthors = () => {
    AxiosInstance.get('author?limit=10&display=true')
      .then((response) => {
        setAuthors(response.data.items);
      })
      .catch((error) => {});
  };

  const { t, i18n } = useTranslation();

  useEffect(() => {
    async function getData() {
      if (isAuth) {
        setRecentBook(await getBook('RECENT_READ'));
        setFavoritesBook(await getBook('FAVORITES'));
      }
      setMostViewedBook(await getBook('MOST_VIEWED'));
      setNewestPublished(await getBook('NEWEST_PUBLISHED'));
      setNewestAdded(await getBook('NEWEST_ADDED'));
    }
    getData();
    getCategories();
    getAuthors();
  }, []);

  return {
    windowDimensions,
    recentBook,
    mostViewedBook,
    newestAdded,
    newestPublished,
    favoritesBook,
    authors,
    categories,
  };
};

export default useForm;
